import React from 'react';

export const MaintenanceRecordsTireRotation = ({
  height = 18,
  width = 18,
  color = 'white',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.83329 5.66699C8.72822 5.66699 7.66841 6.10598 6.88701 6.88738C6.10561 7.66878 5.66663 8.72859 5.66663 9.83366C5.66663 10.9387 6.10561 11.9985 6.88701 12.7799C7.66841 13.5613 8.72822 14.0003 9.83329 14.0003C10.9384 14.0003 11.9982 13.5613 12.7796 12.7799C13.561 11.9985 14 10.9387 14 9.83366C14 8.72859 13.561 7.66878 12.7796 6.88738C11.9982 6.10598 10.9384 5.66699 9.83329 5.66699ZM9.83329 6.50033C10.0543 6.50033 10.2663 6.58812 10.4225 6.7444C10.5788 6.90068 10.6666 7.11265 10.6666 7.33366C10.6666 7.55467 10.5788 7.76663 10.4225 7.92292C10.2663 8.0792 10.0543 8.16699 9.83329 8.16699C9.61228 8.16699 9.40032 8.0792 9.24404 7.92292C9.08776 7.76663 8.99996 7.55467 8.99996 7.33366C8.99996 7.11265 9.08776 6.90068 9.24404 6.7444C9.40032 6.58812 9.61228 6.50033 9.83329 6.50033ZM7.33329 10.667C7.11228 10.667 6.90032 10.5792 6.74404 10.4229C6.58776 10.2666 6.49996 10.0547 6.49996 9.83366C6.49996 9.61265 6.58776 9.40068 6.74404 9.2444C6.90032 9.08812 7.11228 9.00033 7.33329 9.00033C7.55431 9.00033 7.76627 9.08812 7.92255 9.2444C8.07883 9.40068 8.16663 9.61265 8.16663 9.83366C8.16663 10.0547 8.07883 10.2666 7.92255 10.4229C7.76627 10.5792 7.55431 10.667 7.33329 10.667ZM9.83329 13.167C9.61228 13.167 9.40032 13.0792 9.24404 12.9229C9.08776 12.7666 8.99996 12.5547 8.99996 12.3337C8.99996 12.1126 9.08776 11.9007 9.24404 11.7444C9.40032 11.5881 9.61228 11.5003 9.83329 11.5003C10.0543 11.5003 10.2663 11.5881 10.4225 11.7444C10.5788 11.9007 10.6666 12.1126 10.6666 12.3337C10.6666 12.5547 10.5788 12.7666 10.4225 12.9229C10.2663 13.0792 10.0543 13.167 9.83329 13.167ZM9.83329 11.0837C9.50177 11.0837 9.18384 10.952 8.94942 10.7175C8.71499 10.4831 8.58329 10.1652 8.58329 9.83366C8.58329 9.50214 8.71499 9.1842 8.94942 8.94977C9.18384 8.71535 9.50177 8.58366 9.83329 8.58366C10.1648 8.58366 10.4828 8.71535 10.7172 8.94977C10.9516 9.1842 11.0833 9.50214 11.0833 9.83366C11.0833 10.1652 10.9516 10.4831 10.7172 10.7175C10.4828 10.952 10.1648 11.0837 9.83329 11.0837ZM12.3333 10.667C12.1123 10.667 11.9003 10.5792 11.744 10.4229C11.5878 10.2666 11.5 10.0547 11.5 9.83366C11.5 9.61265 11.5878 9.40068 11.744 9.2444C11.9003 9.08812 12.1123 9.00033 12.3333 9.00033C12.5543 9.00033 12.7663 9.08812 12.9225 9.2444C13.0788 9.40068 13.1666 9.61265 13.1666 9.83366C13.1666 10.0547 13.0788 10.2666 12.9225 10.4229C12.7663 10.5792 12.5543 10.667 12.3333 10.667ZM17.3333 9.83366C17.3333 11.8228 16.5431 13.7304 15.1366 15.137C13.7301 16.5435 11.8224 17.3337 9.83329 17.3337C8.13454 17.3327 6.48642 16.7551 5.15874 15.6954C3.83105 14.6357 2.90246 13.1566 2.52496 11.5003H4.24162C4.60061 12.7044 5.3388 13.7604 6.34632 14.5112C7.35383 15.2619 8.57682 15.6673 9.83329 15.667C11.3804 15.667 12.8641 15.0524 13.9581 13.9584C15.052 12.8645 15.6666 11.3808 15.6666 9.83366C15.6669 8.57719 15.2616 7.35419 14.5108 6.34668C13.7601 5.33916 12.7041 4.60099 11.5 4.24199V2.52533C13.1562 2.90283 14.6353 3.83142 15.695 5.15911C16.7547 6.48679 17.3324 8.13491 17.3333 9.83366ZM3.99996 9.83366H0.666626C0.666626 7.40251 1.6324 5.07093 3.35149 3.35185C5.07057 1.63276 7.40214 0.666992 9.83329 0.666992V4.00033C8.2862 4.00033 6.80246 4.61491 5.7085 5.70887C4.61454 6.80283 3.99996 8.28656 3.99996 9.83366Z"
        fill={color}
      />
    </svg>
  );
};

export const MaintenanceRecordsOilChange = ({
  width = 21,
  height = 14,
  color = 'white',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.5477 8.66683C10.6856 8.90648 10.7408 9.1849 10.7046 9.45905C10.6685 9.73319 10.543 9.98779 10.3477 10.1835C10.2322 10.3004 10.0946 10.3932 9.94302 10.4566C9.79139 10.5199 9.62869 10.5525 9.46436 10.5525C9.30002 10.5525 9.13733 10.5199 8.98569 10.4566C8.83406 10.3932 8.69651 10.3004 8.58102 10.1835C8.38568 9.98779 8.26023 9.73319 8.22408 9.45905C8.18793 9.1849 8.24308 8.90648 8.38102 8.66683L9.46436 6.80016L10.5477 8.66683ZM20.7144 1.16683V2.8335H19.5477L13.7144 13.6668H4.04769V2.8335H2.38102V5.3335H0.714355V1.16683H5.71436V3.66683H9.04769V2.00016H7.38102V0.333496H12.381V2.00016H10.7144V3.66683H14.0477V4.55016L18.781 1.16683H20.7144ZM16.6144 4.76683L12.381 7.7835V5.3335H5.71436V12.0002H12.7144L16.6144 4.76683Z"
        fill={color}
      />
    </svg>
  );
};

export const MaintenanceRecordsElectricialSystem = ({
  width = 20,
  height = 16,
  color = 'white',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 8H1.66667V12.1667H0V8ZM18.3333 6.33333V11.3333H20V6.33333H18.3333ZM10.8333 3.83333H12.5V2.16667H15V0.5H8.33333V2.16667H10.8333V3.83333ZM16.6667 5.5V12.1L13.2667 15.5H8.125L5.55 13.8333H3.33333V7.16667H6.73333L8.4 5.5H16.6667ZM15 7.16667H9.1L7.43333 8.83333H5V12.1667H6.04167L8.61666 13.8333H12.5667L15 11.4V7.16667Z"
        fill={color}
      />
    </svg>
  );
};

export const MaintenanceRecordsAdd = ({
  width = 24,
  height = 24,
  color = 'white',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill={color} />
    </svg>
  );
};

export const MaintenanceRecordsFilterList = ({
  width = 20,
  height = 20,
  color = 'white',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.33333 15H11.6667V13.3333H8.33333V15ZM2.5 5V6.66667H17.5V5H2.5ZM5 10.8333H15V9.16667H5V10.8333Z"
        fill={color}
      />
    </svg>
  );
};

export const MaintenanceRecordsSettings = ({
  width = 20,
  height = 20,
  color = 'white',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.9504 10.7836C15.9838 10.5336 16.0004 10.2752 16.0004 10.0002C16.0004 9.73358 15.9838 9.46691 15.9421 9.21691L17.6338 7.90024C17.7838 7.78358 17.8254 7.55858 17.7338 7.39191L16.1338 4.62524C16.0338 4.44191 15.8254 4.38358 15.6421 4.44191L13.6504 5.24191C13.2337 4.92524 12.7921 4.65858 12.3004 4.45858L12.0004 2.34191C11.9671 2.14191 11.8004 2.00024 11.6004 2.00024H8.40042C8.20042 2.00024 8.04208 2.14191 8.00875 2.34191L7.70875 4.45858C7.21708 4.65858 6.76708 4.93358 6.35875 5.24191L4.36708 4.44191C4.18375 4.37524 3.97542 4.44191 3.87542 4.62524L2.28375 7.39191C2.18375 7.56691 2.21708 7.78358 2.38375 7.90024L4.07542 9.21691C4.03375 9.46691 4.00042 9.74191 4.00042 10.0002C4.00042 10.2586 4.01708 10.5336 4.05875 10.7836L2.36708 12.1002C2.21708 12.2169 2.17542 12.4419 2.26708 12.6086L3.86708 15.3752C3.96708 15.5586 4.17542 15.6169 4.35875 15.5586L6.35042 14.7586C6.76708 15.0752 7.20875 15.3419 7.70042 15.5419L8.00042 17.6586C8.04208 17.8586 8.20042 18.0002 8.40042 18.0002H11.6004C11.8004 18.0002 11.9671 17.8586 11.9921 17.6586L12.2921 15.5419C12.7837 15.3419 13.2338 15.0752 13.6421 14.7586L15.6338 15.5586C15.8171 15.6252 16.0254 15.5586 16.1254 15.3752L17.7254 12.6086C17.8254 12.4252 17.7838 12.2169 17.6254 12.1002L15.9504 10.7836ZM10.0004 13.0002C8.35042 13.0002 7.00042 11.6502 7.00042 10.0002C7.00042 8.35024 8.35042 7.00024 10.0004 7.00024C11.6504 7.00024 13.0004 8.35024 13.0004 10.0002C13.0004 11.6502 11.6504 13.0002 10.0004 13.0002Z"
        fill={color}
      />
    </svg>
  );
};

export const MaintenanceRecordsCloseOutlined = ({
  width = 24,
  height = 24,
  color = 'white',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
        fill={color}
      />
    </svg>
  );
};

export const MaintenanceRecordsPeople = ({
  width = 21,
  height = 21,
  color = 'white',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.3916 11.4415C15.5333 12.2165 16.3333 13.2665 16.3333 14.6665V17.1665H19.6666V14.6665C19.6666 12.8498 16.6916 11.7748 14.3916 11.4415Z"
        fill={color}
      />
      <path
        d="M13 10.4999C14.8416 10.4999 16.3333 9.00825 16.3333 7.16658C16.3333 5.32492 14.8416 3.83325 13 3.83325C12.6083 3.83325 12.2416 3.91659 11.8916 4.03325C12.5833 4.89158 13 5.98325 13 7.16658C13 8.34992 12.5833 9.44159 11.8916 10.2999C12.2416 10.4166 12.6083 10.4999 13 10.4999Z"
        fill={color}
      />
      <path
        d="M8.00004 10.4999C9.84171 10.4999 11.3334 9.00825 11.3334 7.16658C11.3334 5.32492 9.84171 3.83325 8.00004 3.83325C6.15837 3.83325 4.66671 5.32492 4.66671 7.16658C4.66671 9.00825 6.15837 10.4999 8.00004 10.4999ZM8.00004 5.49992C8.91671 5.49992 9.66671 6.24992 9.66671 7.16658C9.66671 8.08325 8.91671 8.83325 8.00004 8.83325C7.08337 8.83325 6.33337 8.08325 6.33337 7.16658C6.33337 6.24992 7.08337 5.49992 8.00004 5.49992Z"
        fill={color}
      />
      <path
        d="M8.00004 11.3333C5.77504 11.3333 1.33337 12.4499 1.33337 14.6666V17.1666H14.6667V14.6666C14.6667 12.4499 10.225 11.3333 8.00004 11.3333ZM13 15.4999H3.00004V14.6749C3.16671 14.0749 5.75004 12.9999 8.00004 12.9999C10.25 12.9999 12.8334 14.0749 13 14.6666V15.4999Z"
        fill={color}
      />
    </svg>
  );
};
